import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitButton']

  toggle(event) {
    const value = event.target.value
    // Toggle visibility of storage forms
    const elementIds = ['disk', 'aws_s3', 'google', 'azure']
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId)
      if (element) {
        element.classList.toggle('hidden', value !== elementId)
      }
    })
    // Toggle button disabled state
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !value || value === ''
    }
  }
}
